import moment from 'moment/moment';
import { Separator } from 'src/components/ui/separator';
import { ESCALATION_REASONS } from 'src/pages/ConversationsPage/chatsRequest';

export const ConversationEscalatedMessage = ({
  date,
  reason,
}: {
  date?: string;
  // An escalation_reason_category value; unknown or missing values show no reason.
  reason?: string;
}) => {
  const reasonLabel = ESCALATION_REASONS.find(({ value }) => value === reason)?.label;

  return (
    <li
      className={
        'list-none flex text-sm font-medium flex-row w-full justify-center items-center relative mt-4'
      }
    >
      <div
        className={
          'py-2 px-4 rounded-sm-5 border border-[#C11A45] text-xs text-[#C11A45] bg-white z-10 capitalize'
        }
      >
        Escalated – {moment(date).format('lll')}
        {reasonLabel && ` · Reason: ${reasonLabel}`}
      </div>
      <Separator className={'!bg-[#C11A45] w-full absolute top-[50%]'} />
    </li>
  );
};
